import { observable, toJS, computed, action } from "mobx";

import { getParameterByName } from "@utils/Browser";

class ProfileStore {
	constructor(rootStore, staticContext) {
		this.rootStore = rootStore;
		this._provider = staticContext.provider;
		this._lead = staticContext.lead;
		this._quote = staticContext.quote;
		this._service = staticContext.service;
		this._reviews = staticContext.reviews;
		this._location = staticContext.app.location;
		this.estimated_price = staticContext.estimated_price;
		this.cityServiceStat = staticContext.cityServiceStat;
		this.searched_location = staticContext.searched_location;
		this._provider_questions_answers = staticContext.provider_questions_answers;
	}

	@action
	async init() {}

	@observable _provider = null;
	@computed
	get provider() {
		return toJS(this._provider);
	}

	@observable _lead = null;
	@computed
	get lead() {
		return toJS(this._lead);
	}

	@observable _quote = null;
	@computed
	get quote() {
		return toJS(this._quote);
	}

	set quote(quote) {
		this._quote = quote;
	}

	@observable _service = null;
	get service() {
		return this._service;
	}

	set service(service) {
		this._service = service;
	}

	@observable _reviews = [];
	get reviews() {
		return toJS(this._reviews);
	}

	@observable _location = null;
	get location() {
		return toJS(this._location);
	}

	get leadKey() {
		return getParameterByName("leadKey");
	}

	get zipcode() {
		return (
			getParameterByName("zipcode") ||
			(this._location ? this._location.zipcode : "")
		);
	}

	get serviceKey() {
		return getParameterByName("service");
	}

	get serveLocation() {
		if (this.searched_location?.city) {
			return `${this.searched_location?.city?.ucFirst()} ${
				this.searched_location?.state?.toUpperCase() ? "," : ""
			} ${this.searched_location?.state?.toUpperCase()}`;
		}
		return `${this.provider.business_location?.city?.ucFirst()} ${
			this.provider.business_location?.state?.toUpperCase() ? "," : ""
		} ${this.provider.business_location?.state?.toUpperCase()}`;
	}

	@observable _provider_questions_answers = [];
	@computed
	get provider_questions_answers() {
		return toJS(this._provider_questions_answers);
	}

	get shouldShowDetails() {
		return this._provider_questions_answers.length > 0;
	}
}

export default ProfileStore;
